import { toast } from "sonner";
import { mh, AUTONOMY } from "@/lib/mh";
import { cn } from "@/lib/utils";
import { useAuth } from "@/context/AuthContext";

const COPY = {
  "Human-led": "Every action waits for a person.",
  "Human-assisted": "Agents draft; humans sign off on impact.",
  "Fully autonomous": "Agents ship; humans see low-confidence only.",
};

export const AutonomyDial = ({ slug, value, hex, onChange }) => {
  const { canManage } = useAuth();
  const set = async (level) => {
    try {
      await mh.setAutonomy(slug, level);
      onChange?.(level);
      toast.success(`Autonomy cap set to ${level}`);
    } catch {
      toast.error("Could not change autonomy");
    }
  };
  return (
    <div data-testid="autonomy-dial">
      <div className="inline-flex p-1 rounded-full border border-white/10 bg-white/[0.03]">
        {AUTONOMY.map((a) => (
          <button key={a} disabled={!canManage} onClick={() => set(a)} data-testid={`autonomy-${a.toLowerCase().replace(/\s/g, "-")}`}
            className={cn("px-2.5 sm:px-3.5 h-8 rounded-full text-[11px] sm:text-xs font-medium whitespace-nowrap transition-[background-color,color] duration-200", value === a ? "text-black" : "text-muted-foreground hover:text-foreground")}
            style={value === a ? { background: hex } : undefined}>
            {a}
          </button>
        ))}
      </div>
      <p className="font-mono text-[11px] text-muted-foreground mt-2">{COPY[value]}</p>
    </div>
  );
};
